import { DefaultService } from '@/services/DefaultService';

export default class EventoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(lps) {
        return this._http.post(`${this._env}/promotor/event`, lps, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/event/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/event/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(column, order, page = 0, limit = 50, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/event.json?column=${column}&order=${order}&page=${page}&limit=${limit}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllCombo(...params) {
        return this._http
            .get(
                encodeURI(`${this._env}/promotor/getcombo/event.json?param=${params}`),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(lps) {
        return this._http
            .post(`${this._env}/promotor/event/updatesituacao`, lps, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
